// src/App.js
import React from 'react';
import { Routes, Route } from 'react-router-dom';

import Home from './pages/Home';
import ContactPage from './pages/ContactPage.jsx';
import ServicesPage from './pages/ServicesPage.jsx';
import ManagerDashboard from './pages/ManagerDashboard';
import OwnerDashboard from './dashboards/Owner.jsx';
import TenantDashboard from './pages/TenantDashboard';
import BookingForm from './pages/BookingForm.jsx';
import BookingList from './dashboards/Manager/Lists/BookingList.jsx';
import ExpensesDetailsAdd from "./pages/ExpensesDetailsAdd.jsx";




import Navbar from './components/Navbar/Navbar';
import Footer from './components/Footer';

import TenantAdd from './dashboards/Manager/Add/TenantAdd';
import ApartmentUnitAdd from './dashboards/Manager/Add/ApartmentUnitAdd';
import ApartmentUnitsList from './dashboards/Manager/Lists/ApartmentUnitsList';
import UserManagementTable from './dashboards/Manager/Lists/UserManagementTable.jsx';
import Materials from './dashboards/Manager/Lists/Materials';
import TenantView from './dashboards/Manager/Lists/TenantView.jsx';
import Expenses from './dashboards/Manager/Lists/Expenses';
import EditApartmentUnit from './dashboards/Manager/Updates/EditApartmentUnit';
import GuardDashboard from './components/GuardDashboard.jsx';
import RentalManagerDashboard from './components/RentalHouses/RentalManagerDashboard.jsx';
import AttendanceForm from './components/AttendanceForm.jsx';
import GuardForm from './components/GuardForm.jsx';
import GuardReport from './components/GuardReport.jsx';
import EditGuardPage from "./components/EditGuardPage.jsx";
import EditAttendance from "./components/EditAttendance.jsx";
import GuardList from "./components/GuardList.jsx";
import OurServices from "./pages/OurServices.jsx";
import LandingPage from "./components/RentalHouses/LandingPage.jsx";




import { ExpensesReport, TenantsReport } from './dashboards/Manager/Report/Reports.jsx';
import IncomeReport from './components/IncomeReport';
import ProfitLossReport from './pages/ProfitLossReport/ProfitLossReport';

import MaintenanceUnits from './dashboards/Manager/Lists/MaintenanceUnits.jsx';
import HomeManagement from './dashboards/Manager/Lists/InventoryManagement.jsx';
import SlideManagement from './dashboards/Manager/Lists/SlidesManager.jsx';


import Notification from './components/Notification.jsx';
import TenantVerification from './pages/TenantVerification.jsx';

import TenantProfil from './pages/TenantsSide/TenantProfil.jsx';
import BookingDashboard from './pages/TenantsSide/BookingDashboard.jsx';
import TenantNotifications from './pages/TenantsSide/TenantNotifications.jsx';
import TenantListView from './pages/TenantsSide/TenantListView.jsx';

import RegisterForm from './pages/SignUp.jsx';
import LoginWithOtp from './pages/LoginWithOtp.jsx';
import ForgotPasswordForm from './pages/ForgotPasswordForm';
import ResetPasswordForm from './pages/ResetPasswordForm';
import MaterialsName from './pages/MaterialsName.jsx';
import HouseManagement from './pages/HouseManagement.jsx';

import EditTenant from './dashboards/Manager/Updates/EditTenant.jsx';
import UpdateMaterial from './dashboards/Manager/Updates/UpdateMaterial.jsx';

import ContactMessagesList from './pages/ContactMessagesList.jsx';
import ProtectedRoute from './ProtectedRoute/ProtectedRoute.jsx';

import './App.css';
import StockOut from './pages/StockOut.jsx';
import AllMaterials from './pages/AllMaterials.jsx';
import Report from './pages/MaterialReport.jsx';
import AddMaterial from './pages/AddMaterial.jsx';

function App() {
  return (
    <div className="app-layout">
      {/* NAVBAR */}
      <Navbar />

      {/* MAIN CONTENT - Forced to full width via CSS */}
      <main className="app-content">
        <Routes>
          {/* ===== PUBLIC ===== */}
          <Route path="/" element={<Home />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/Booking" element={<BookingForm />} />
          <Route path="/Booking_List" element={<BookingList />} />
          <Route path="/services" element={<ServicesPage />} />
          <Route path="/SignUp/*" element={<RegisterForm />} />
          <Route path="/Login/*" element={<LoginWithOtp />} />
          <Route path="/forgot-password" element={<ForgotPasswordForm />} />
          <Route path="/reset-password" element={<ResetPasswordForm />} />
          <Route path="/Attendence/Edit/:id" element={<EditAttendance />} />

          {/* ===== TENANT ===== */}
          <Route path="/tenant/*" element={<ProtectedRoute><TenantDashboard /></ProtectedRoute>} />
          <Route path="/tenant/profile" element={<ProtectedRoute><TenantProfil /></ProtectedRoute>} />
          <Route path="/tenant/BookingDash" element={<ProtectedRoute><BookingDashboard /></ProtectedRoute>} />
          <Route path="/notifctToTena" element={<ProtectedRoute><TenantNotifications /></ProtectedRoute>} />
          <Route path="/tenant/notification" element={<ProtectedRoute><TenantListView /></ProtectedRoute>} />
          <Route path="/guards" element={<ProtectedRoute><GuardList /></ProtectedRoute>} />
          <Route path="/verify" element={<TenantVerification />} />
          <Route path="/edit-guard/:id" element={<ProtectedRoute><EditGuardPage /></ProtectedRoute>} />
          <Route path="/Our_services" element={<OurServices />} />
          <Route path="/rental" element={<ProtectedRoute><RentalManagerDashboard /></ProtectedRoute>} />
          <Route path="/ExpDetails" element={<ProtectedRoute><ExpensesDetailsAdd /></ProtectedRoute>} />
          <Route path="/rentalhouses" element={<HouseManagement />} />
          <Route path="/RentalLandingPage" element={<LandingPage />} />
          
          

          {/* ===== MANAGER ===== */}
          <Route path="/manager/*" element={<ProtectedRoute><ManagerDashboard /></ProtectedRoute>} />
          <Route path="/manager/Home" element={<ProtectedRoute><HomeManagement /></ProtectedRoute>} />
          <Route path="/manager/Slide" element={<ProtectedRoute><SlideManagement /></ProtectedRoute>} />
          <Route path="/manager/tenant/view/:id" element={<ProtectedRoute><TenantView /></ProtectedRoute>} />
          <Route path="/manager/guards" element={<ProtectedRoute><GuardDashboard /></ProtectedRoute>} />
          <Route path="/report_guards" element={<ProtectedRoute><GuardReport /></ProtectedRoute>} />
          

          {/* ===== OWNER ===== */}
          <Route path="/owner/*" element={<ProtectedRoute><OwnerDashboard /></ProtectedRoute>} />

          {/* ===== CRUD ===== */}
          <Route path="/add-tenant" element={<ProtectedRoute><TenantAdd /></ProtectedRoute>} />
          <Route path="/add-apartment-unit" element={<ProtectedRoute><ApartmentUnitAdd /></ProtectedRoute>} />
          <Route path="/manager/apartment-units" element={<ProtectedRoute><ApartmentUnitsList /></ProtectedRoute>} />
          <Route path="/manager/accounts" element={<ProtectedRoute><UserManagementTable /></ProtectedRoute>} />
          {/* <Route path="/manager/MaterialsManagement" element={<ProtectedRoute><Materials /></ProtectedRoute>} /> */}
          <Route path="/manager/Expences" element={<ProtectedRoute><Expenses /></ProtectedRoute>} />

          {/* Materials */}

          <Route path="/add-Materials" element={<ProtectedRoute><AddMaterial /></ProtectedRoute>} />
          <Route path="/stock_out" element={<ProtectedRoute><StockOut /></ProtectedRoute>} />
          <Route path="/all-Materials" element={<ProtectedRoute><AllMaterials /></ProtectedRoute>} />
          <Route path="/materialName" element={<ProtectedRoute><MaterialsName /></ProtectedRoute>} />

      
          {/* ===== UPDATE ===== */}
          <Route path="/edit-apartment-unit/:id" element={<ProtectedRoute><EditApartmentUnit /></ProtectedRoute>} />
          <Route path="/manager/tenant/edit/:id" element={<ProtectedRoute><EditTenant /></ProtectedRoute>} />
          <Route path="/manager/update-material/:id" element={<ProtectedRoute><UpdateMaterial /></ProtectedRoute>} />

          {/* ===== REPORTS ===== */}
          <Route path="/reports/expenses" element={<ProtectedRoute><ExpensesReport /></ProtectedRoute>} />
          <Route path="/reports/tenants" element={<ProtectedRoute><TenantsReport /></ProtectedRoute>} />
          <Route path="/reports/income" element={<ProtectedRoute><IncomeReport /></ProtectedRoute>} />
          <Route path="/profit-loss-report" element={<ProtectedRoute><ProfitLossReport /></ProtectedRoute>} />

          {/* ===== OTHER ===== */}
          <Route path="/manager/Maintenance" element={<ProtectedRoute><MaintenanceUnits /></ProtectedRoute>} />
          <Route path="/manager/notification" element={<ProtectedRoute><Notification /></ProtectedRoute>} />
          <Route path="/manager/messagecontact" element={<ProtectedRoute><ContactMessagesList /></ProtectedRoute>} />
          <Route path="/attendance" element={<ProtectedRoute><AttendanceForm /></ProtectedRoute>} />
          <Route path="/add-guard" element={<ProtectedRoute><GuardForm /></ProtectedRoute>} />

 
        </Routes>
      </main>

      {/* FOOTER */}
      <Footer />
    </div>
  );
}

export default App;